import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from "classnames"


class FormGroup extends Component {
    render() {

        let {children, meta, ...customProps} = this.props
        let { touched, error, warning } = meta
        let {type, className = ""} = customProps
        const {formatMessage} = this.context

        return (
            <div className = {cn({
                "form-group" : type !== 'checkbox',
                "checkbox" : type === 'checkbox',
                "has-error" : (touched && error),
                "has-warning" : (touched && warning),
            }, className)}>
                {
                    children
                }
                {
                    this.renderErrorWarning()
                }
            </div>
        )

        return touched &&
            (
                (
                    error &&
                    <span className = "help-block">{typeof formatMessage === 'function' ? formatMessage(error) : error}</span>
                )
                ||
                (
                    warning &&
                    <span className = "help-block">{warning}</span>
                )
            )
    }

    renderErrorWarning = () => {
        let {meta} = this.props
        let { touched, error, warning } = meta

        const {formatMessage} = this.context

        return touched &&
            (
                (
                    error &&
                    <span className = "help-block">{formatMessage ? formatMessage(error) : error}</span>
                )
                ||
                (
                    warning &&
                    <span className = "help-block">{warning}</span>
                )
            )
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default FormGroup


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/FormGroup.js